import { useState, useEffect } from 'react';

export default function Hero() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="relative bg-gradient-to-br from-[#FAF8F5] to-[#F5F1EB] overflow-hidden">
      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img 
              src="https://public.readdy.ai/ai/img_res/235f330b-f882-4107-a5d6-be34726515e3.png" 
              alt="Charleston Junk Removers Logo" 
              className="h-12 w-auto"
            />
            <span className="text-xl font-bold text-[#2C2C2C] uppercase tracking-tight">Charleston Junk Removers</span>
          </div>
          <div className="hidden md:flex items-center gap-8">
            <a href="#pricing" className="text-[#2C2C2C] hover:text-[#FF6B4A] transition-colors text-sm font-medium">Pricing</a>
            <a href="#why-us" className="text-[#2C2C2C] hover:text-[#FF6B4A] transition-colors text-sm font-medium">Why Us</a>
            <a href="#faq" className="text-[#2C2C2C] hover:text-[#FF6B4A] transition-colors text-sm font-medium">FAQ</a>
            <a href="#contact" className="text-[#2C2C2C] hover:text-[#FF6B4A] transition-colors text-sm font-medium">Contact</a>
            <a href="tel:+15134489448" className="bg-[#FF6B4A] text-white px-6 py-2.5 rounded-full hover:bg-[#ff5533] transition-all whitespace-nowrap text-sm font-medium">
              Call Now
            </a>
          </div>
        </div>
      </nav>

      {/* Hero Content */}
      <div className="max-w-7xl mx-auto px-6 pt-32 pb-20 flex flex-col lg:flex-row items-center gap-12">
        {/* Left Content - 45% */}
        <div className="flex-1 lg:max-w-[45%]">
          <h1 className="text-6xl lg:text-7xl font-serif leading-tight text-[#2C2C2C] mb-8">
            Fast, Hassle-Free<br />
            Junk Removal in<br />
            <span className="text-[#FF6B4A]">Charleston</span>
          </h1>
          <p className="text-lg text-[#6B7280] mb-12 leading-relaxed max-w-xl">
            Same-day service, transparent pricing, and professional crews ready to clear your space today.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <a 
              href="tel:+15134489448" 
              className="bg-[#FF6B4A] text-white px-8 py-4 rounded-full hover:bg-[#ff5533] transition-all whitespace-nowrap text-base font-semibold flex items-center justify-center gap-2 shadow-lg hover:shadow-xl"
            >
              <i className="ri-phone-fill"></i>
              Call Now for Free Estimate
            </a>
            <a 
              href="#booking" 
              className="border-2 border-[#2C2C2C] text-[#2C2C2C] px-8 py-4 rounded-full hover:bg-[#2C2C2C] hover:text-white transition-all whitespace-nowrap text-base font-semibold flex items-center justify-center gap-2"
            >
              Book Online Instantly
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>

        {/* Right Visual - 55% */}
        <div className="flex-1 lg:max-w-[55%] relative">
          <div className="relative rounded-3xl overflow-hidden shadow-2xl">
            <img 
              src="https://public.readdy.ai/ai/img_res/da6b4ae133ade6a244721907038da3f5.jpg" 
              alt="Professional junk removal crew at work" 
              className="w-full h-auto object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
            
            {/* Floating Badge */}
            <div className="absolute top-6 right-6 bg-white rounded-full px-6 py-3 shadow-lg flex items-center gap-2">
              <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse"></div>
              <span className="text-sm font-semibold text-[#2C2C2C]">Same-Day Service</span>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative Pattern */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%232C2C2C' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
        }}></div>
      </div>
    </div>
  );
}
